import { useState } from "react"
import { bool, func, instanceOf, object, string } from "prop-types"
import DayPickerInput from "react-day-picker/DayPickerInput"
import DayPickerMonthYearSelect from "./DayPickerMonthYearSelect"
import moment from "moment-timezone"
import { momentDateTime } from "utils/dates"

const DatePicker = ({
  onChange = () => {},
  disabled,
  format,
  fromMonth,
  id,
  name,
  style,
  toMonth,
  datetime
}) => {
  const [month, setMonth] = useState(fromMonth)
  const { momentDateFormat } = App?.currentOrganization || {}

  const parseDate = str => {
    const momentDate = moment(str, format, true).startOf("day")

    if (momentDate.isValid()) {
      return momentDate.toDate()
    }

    return undefined
  }

  const formatDate = str => {
    return moment(str)
      .startOf("day")
      .format(format)
  }

  if (typeof datetime === "string" && datetime !== "") {
    datetime = moment(datetime, format)
  }

  format = format || momentDateFormat || "M/D/YYYY"
  fromMonth =
    fromMonth ||
    moment()
      .subtract(100, "years")
      .toDate()
  toMonth =
    toMonth ||
    moment()
      .add(2, "years")
      .toDate()

  const DayPickerCaption = ({ date, localeUtils }) => {
    // When dealing with significant timezone differences, first of the month at 12:00
    // translates to the month before, which messes up the month shown in the UI. shifting
    // forward a few days prevents the month slipping backward.
    const shiftedDate = moment(date)
      .add(2, "days")
      .toDate()
    return (
      <DayPickerMonthYearSelect
        date={shiftedDate}
        localeUtils={localeUtils}
        onChange={setMonth}
        fromMonth={fromMonth}
        toMonth={toMonth}
      />
    )
  }

  DayPickerCaption.propTypes = {
    date: instanceOf(Date),
    localeUtils: object
  }

  const inputProps = { disabled, id, name, style }
  const dayPickerProps = {
    captionElement: DayPickerCaption,
    month,
    fromMonth,
    toMonth
  }

  const handleChange = date => {
    if (onChange) {
      date = moment(date).startOf("day")
      const momentDatetime = moment(datetime)
      const time = momentDatetime.isValid()
        ? momentDatetime.format(App.currentOrganization.momentTimeFormat)
        : undefined
      onChange(momentDateTime(date, time).format())
    }
  }

  return (
    <DayPickerInput
      dayPickerProps={dayPickerProps}
      format={format}
      formatDate={formatDate}
      inputProps={inputProps}
      keepFocus={false}
      onDayChange={handleChange}
      parseDate={parseDate}
      placeholder={formatDate()}
      value={datetime ? formatDate(datetime) : null}
    />
  )
}

DatePicker.propTypes = {
  disabled: bool,
  format: string,
  timezone: string,
  fromMonth: instanceOf(Date),
  id: string,
  name: string,
  onChange: func,
  style: object,
  toMonth: instanceOf(Date),
  datetime: string
}

export default DatePicker
